
import { Component, Vue } from 'vue-property-decorator';
import isImageSizeValid from '@/util/is-image-size-valid';
import SingleImageUpload from '@/component/single-image-upload.vue';
import { UPLOAD_DIR } from '@/constants';
const { VUE_APP_FCAPI: FCAPI } = process.env;
const API = {
  add: `${FCAPI}/boss/ruan/community`,
  query_unit: `${FCAPI}/boss/ruan/unit`,
};

const OPTION_LIST = [
  {
    title: '标签',
    dataIndex: 'tag',
    align: 'center',
  },
  {
    title: '户型图',
    align: 'center',
    dataIndex: 'unit_img_url',
    scopedSlots: { customRender: 'image' },
  },
  {
    title: '操作',
    align: 'center',
    scopedSlots: { customRender: 'operation' },
  },
];
interface UNIT {
  community_id?: number;
  create_time?: number;
  id?: number;
  tag: string;
  unit_img_url: string;
  update_time?: number;
  key?: number;
}
@Component({
  components: {
    SingleImageUpload,
  },
})
export default class CommunityAdd extends Vue {
  page_title = '新增小区';
  columns = OPTION_LIST;
  unit_list: UNIT[] = [];
  is_loading = false;
  is_show = false;
  form = {
    name: {
      data: '',
      status: '',
      error: '',
    },
    city: {
      data: '',
      status: '',
      error: '',
    },
    list_img_url: {
      data: '',
      status: '',
      error: '',
    },
    unit: {
      data: {
        img_url: '',
        name: '',
      },
      status: '',
      error: '',
      status_img: '',
      error_img: '',
    },
  };
  img_url = '';
  UPLOAD_DIR = UPLOAD_DIR;
  preview_image = '';
  preview_visible = false;
  page = 1;
  table_data = {};
  id: any = 0;
  unit_data: any = {};
  key = 0;
  created() {
    this.id = this.$route.params.id;
    if (this.id !== '0') {
      this.query();
      this.queryUnit();
    }
  }
  // 需要发送的数据
  sendData() {
    let form = {};
    form = {
      name: this.form.name.data,
      city: this.form.city.data,
      list_img_url: this.form.list_img_url.data,
    };
    return form;
  }
  async edit() {
    const { data } = await this.$axios.put(
      `${API.add}/${this.id}`,
      this.sendData()
    );
    if (data.status !== 200) {
      this.is_loading = false;
      this.$message.error(data.message);
      return;
    }
    this.$router.push({
      path: '/ruan/community',
    });
    return data;
  }
  async add() {
    const { data } = await this.$axios.post(API.add, this.sendData());
    if (data.status !== 200) {
      this.is_loading = false;
      this.$message.error(data.message);
      return;
    }
    return data;
  }
  // 提交新增数据
  async submitSave() {
    if (!this.validator()) {
      return;
    }
    this.is_loading = true;
    // 如果是编辑
    if (this.id !== '0') {
      this.edit();
    } else {
      const _data = await this.add();
      if (!_data) return;
      const community_id = _data.data.id;
      this.unit_list.forEach((item: any) => {
        item['community_id'] = community_id;
      });
      const { data } = await this.$axios.post(API.query_unit, {
        records: this.unit_list,
      });
      this.is_loading = false;

      if (data.status !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.$router.push({
        path: '/ruan/community',
      });
    }
    this.is_loading = false;
  }
  // 查询小区详情
  async query() {
    this.is_loading = true;
    const { data } = await this.$axios.get(
      `${API.add}/${this.$route.params.id}/edit`
    );
    this.is_loading = false;
    if (data.status !== 200) return;
    this.form.name.data = data.data.name;
    this.form.city.data = data.data.city;
    this.form.list_img_url.data = data.data.list_img_url;
  }
  // 查询户型图
  async queryUnit(page = 1) {
    this.page = page;
    this.unit_list = [];
    const { data } = await this.$axios.get(`${API.query_unit}`, {
      params: {
        current: this.page,
        community_id: this.$route.params.id,
      },
    });
    if (data.status !== 200) {
      return;
    }
    const list = data.data.detail;
    this.table_data = data.data;
    list.forEach((item: UNIT) => this.unit_list.push(item));
  }
  // 新增户型图
  async submitAddUnit() {
    if (!this.checkUnit()) return;
    if (this.id !== '0') {
      const { data } = await this.$axios.post(API.query_unit, {
        community_id: this.id,
        unit_img_url: this.form.unit.data.img_url,
        tag: this.form.unit.data.name,
      });
      if (data.status !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.is_show = false;
      this.form.unit.data.img_url = '';
      this.form.unit.data.name = '';
      this.queryUnit(this.page);
    } else {
      this.unit_list.push({
        key: this.key,
        tag: this.form.unit.data.name,
        unit_img_url: this.form.unit.data.img_url,
      });
      this.key++;
      this.table_data = {
        current: 1,
        limit: 5,
        total: this.unit_list.length,
      };
      this.is_show = false;
      this.form.unit.data.name = '';
      this.form.unit.data.img_url = '';
    }
  }
  // 删除户型图
  async handleDelete(record: any) {
    if (this.id !== '0') {
      const { data } = await this.$axios.delete(
        `${API.query_unit}/${record.id}`
      );
      if (data.status !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.queryUnit(this.page);
      this.$message.success('删除成功');
    } else {
      this.unit_list.forEach((item: any, index: number) => {
        if (item.key === record.key) {
          this.unit_list.splice(index, 1);
        }
      });
    }
  }
  // 列表图片上传前
  beforeIndexImgUpload(file: any) {
    if (file.size / 1024 > 2048) {
      this.$message.error('图片过大，请上传 2M 以内图片');
      return false;
    }
    return isImageSizeValid(
      file,
      (width: number, height: number) => width === 670 && height === 313
    ).catch((data: any) => {
      const { width, height } = data;
      this.$message.error(
        `图片宽高限定 670*313px，当前上传图片宽高为 ${width}*${height}`
      );
      return Promise.reject(null);
    });
  }
  // 户型图图片上传前
  beforeIndexImgUploadUnit(file: any) {
    if (file.size / 1024 > 2048) {
      this.$message.error('图片过大，请上传 2M 以内图片');
      return false;
    }
    return isImageSizeValid(
      file,
      (width: number, height: number) => width === 750 && height === 750
    ).catch((data: any) => {
      const { width, height } = data;
      this.$message.error(
        `图片宽高限定 750*750px，当前上传图片宽高为 ${width}*${height}`
      );
      return Promise.reject(null);
    });
  }
  // 验证
  checkChange(field: any) {
    let error = '0';
    if (field === 'name') {
      if (!this.form.name.data) {
        this.form.name.status = 'error';
        this.form.name.error = '请输入小区名称';
        error = '1';
      } else {
        this.form.name.status = '';
        this.form.name.error = '';
      }
      return error;
    }
    if (field === 'city') {
      if (!this.form.city.data) {
        this.form.city.status = 'error';
        this.form.city.error = '请输入城市名称';
        error = '1';
      } else {
        this.form.city.status = '';
        this.form.city.error = '';
      }
      return error;
    }
    if (field === 'list_img_url') {
      if (!this.form.list_img_url.data) {
        this.form.list_img_url.status = 'error';
        this.form.list_img_url.error = '请上传列表图';
        error = '1';
      } else {
        this.form.list_img_url.status = '';
        this.form.list_img_url.error = '';
      }
      return error;
    }

    return error;
  }
  // 验证户型图上传
  checkUnit() {
    let flag = 0;
    if (!this.form.unit.data.name) {
      this.form.unit.status = 'error';
      this.form.unit.error = '请填写标签名';
      flag = 0;
    } else {
      this.form.unit.status = '';
      this.form.unit.error = '';
      flag = 1;
    }
    if (!this.form.unit.data.img_url) {
      this.form.unit.status_img = 'error';
      this.form.unit.error_img = '请上传户型图';
      flag = 0;
    } else {
      this.form.unit.status_img = '';
      this.form.unit.error_img = '';
      flag = flag / 1;
    }
    return flag;
  }
  // 校验数据是否为空
  validator() {
    let is_valid = true;
    const valid = [];
    for (const key in this.form) {
      if (key) {
        valid.push(this.checkChange(key));
      }
    }
    this.$forceUpdate();
    if (valid.indexOf('1') !== -1) {
      is_valid = false;
    }
    return is_valid;
  }
  // 预览
  handlePreview(imageUrl: string) {
    this.preview_image = imageUrl;
    this.preview_visible = true;
  }
  // 取消
  cancleUnitModal() {
    this.is_show = false;
    this.form.unit.status = '';
    this.form.unit.error = '';
    this.form.unit.status_img = '';
    this.form.unit.error_img = '';
  }
  handlePreviewCancel() {
    this.preview_visible = false;
  }
  // 分页
  paginationOption(data: Pagination<any>) {
    return {
      total: data.total || 0,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      showTotal: (total: number) => `共${data.total}条，每页${data.limit}条`,
      pageSize: data.limit || 1,
      current: data.current || 1,
    };
  }
  // 页数改变
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  handChangePaging(pagination: any, table_filters: any, sorter: any) {
    const next_page = pagination.current;
    this.queryUnit(next_page);
  }
}
